import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRouter from './router/AppRouter';
import { TelemetryProvider } from './telemetry/TelemetryProvider';
import ErrorBoundary from './components/ErrorBoundary';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { UserProvider } from './contexts/UserContext';
import { JobsProvider } from './contexts/JobsContext';
import { ModalHostProvider } from './contexts/ModalHostContext';
import { NotificationsProvider } from './contexts/NotificationsContext';
import InsufficientCreditsHost from './components/InsufficientCreditsHost';
import CookieBanner from './components/CookieBanner';
import './style.css';

const rootElement = document.getElementById('app');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <ErrorBoundary>
      <TelemetryProvider>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID ?? 'YOUR_GOOGLE_CLIENT_ID'}>
          <UserProvider>
            <JobsProvider>
              <ModalHostProvider>
                <NotificationsProvider>
                  <AppRouter />
                  <InsufficientCreditsHost />
                  <CookieBanner />
                </NotificationsProvider>
              </ModalHostProvider>
            </JobsProvider>
          </UserProvider>
        </GoogleOAuthProvider>
      </TelemetryProvider>
    </ErrorBoundary>
  );
}
